<template>
  <div class="conversation-details-message">
    <div class="avatar-initials mr-3">
      {{ getUserInitials(message) }}
    </div>
    <div class="d-flex flex-column full-width">
      <div
        class="d-flex justify-space-between align-center full-width flex-wrap"
      >
        <div class="d-flex flex-wrap">
          <span class="font-weight-bold mr-2">
            {{ message.sender | fullName }}
          </span>
          <span class="secondary-text">
            {{ getUserContact(message) }}
          </span>
        </div>
        <span class="secondary-text">
          {{ message.sentDate | timeForHumans }}
        </span>
      </div>
      <div class="mt-5" v-html="message.body" v-if="isEmail" />
      <div class="mt-5" v-else>
        {{ message.body }}
      </div>
      <div class="mt-4" v-if="hasAttachments">
        <FileComponent
          class="pb-2"
          v-for="attachment in message.attachments"
          :key="attachment.id"
          :file="attachment"
          @show="showFile(attachment)"
          customActions
          disabled
          :showFileName="!isMobile"
        />
      </div>
    </div>
    <PDFViewFull :data="fileDialog" />
  </div>
</template>

<script>
import { getNameInitials } from "@/utils/helpers";
import { getTimeForHumans } from "@/utils/helpers";
import { getToken } from "@/services/utils";
import FileComponent from "@/components/common/FileComponent";
import PDFViewFull from "@/components/common/PDFViewFull";
import { size } from "lodash";

export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    isEmail: Boolean
  },
  components: { FileComponent, PDFViewFull },
  data() {
    return {
      fileDialog: { dialog: false }
    };
  },
  computed: {
    hasAttachments() {
      return size(this.message.attachments);
    }
  },
  methods: {
    getUserInitials({ sender }) {
      return getNameInitials(sender);
    },
    getUserContact({ sender }) {
      return `<${this.isEmail ? sender.email : sender.phone}>`;
    },
    showFile(attachment) {
      this.fileDialog = {
        src: this.fileUrl(attachment.url),
        title: attachment.fileName,
        dialog: true
      };
    },
    fileUrl(url) {
      const token = `token=${getToken()}`;
      return `${url}?${token}`;
    }
  },
  filters: {
    timeForHumans(date) {
      return getTimeForHumans(date);
    }
  }
};
</script>

<style lang="scss">
.conversation-details-message {
  padding: 30px 0;
  display: flex;
  border-bottom: 2px solid $secondary-line;
}
</style>
